var generateStyle = function generateStyle(componentTheme, props) {
  var attachQuestionContainer = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    zIndex: '4444'
  };
  var addContentContainer = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    position: 'relative',
    height: '1px',
    zIndex: '4444'
  };
  return {
    wrapper: props.useStimulusTrigger ? attachQuestionContainer : addContentContainer,
    borderLine: {
      top: 0,
      width: '100%',
      borderBottom: "solid ".concat(componentTheme.borderLineBorderWidth, " ").concat(componentTheme.borderLineBorderColor)
    }
  };
};
export default generateStyle;